module.exports = __webpack_public_path__ + "static/GuardianA-0c393345c9a45aa557d768b6a2da9216.gif";